import { PROTOCOL, HOST, APP_LANGUAGE } from '../index';

/**
 * @name FEEDBACK_TOKEN
 * @const
 * @object
 * @description Contains the language tokens for the feedback URL
 */
export const FEEDBACK_TOKEN = {
    
    /**
     * @name EN
     * @string
     * @description Token for English
     */
    EN: '355b766d-127192-c733c77b-141a-42d7-be9f-2e52b426622b',

    /**
     * @name JA
     * @string
     * @description Token for Japanese
     */
    JA: '355b766d-127194-c733c77b-141a-42d7-be9f-2e52b426622b',

    /**
     * @name ZH
     * @string
     * @description Token for Chinese
     */
    ZH: '355b766d-127193-c733c77b-141a-42d7-be9f-2e52b426622b'
};

/**
 * @name FEEDBACK_URL
 * @const
 * @description Contains the URL for the feed back form. 
 * Requires the `{token}` to replaced with a value from `FEEDBACK_TOKEN`
 */
export const FEEDBACK_URL = 'https://ips-invite.iperceptions.com/webValidator.aspx?sdfc={token}&lID=1&source=102226';

export const EXCEL_FILENAME = `${ PROTOCOL }//${ HOST }/${ APP_LANGUAGE }/parametricsearch/PSTHandler/DownloadPstAsExcel`;